const download = {
  state: {
    downloadList: []
  },
  getters: {
    downloadList: state => state.downloadList
  },
  mutations: {
    pushDownloadFile: (state, file) => {
      console.log('push', state.downloadList, file, Object.keys(state))
      state.downloadList.push(file)
    },
    removeDownloadFile: (state, file) => {
      const index = state.downloadList.findIndex(obj => obj.filePath === file.filePath)
      state.downloadList.splice(index, 1)
      // for (var i in state.downloadList) {
      //   const item = state.downloadList[i]
      //   if (item.filePath === file.filePath) {
      //     state.downloadList.splice(i, 1)
      //   }
      // }
      console.log('remove', state.downloadList)
    }
  },
  actions: {
    pushDownloadFile ({ commit }, file) {
      commit('pushDownloadFile', file)
    },
    removeDownloadFile ({ commit }, file) {
      commit('removeDownloadFile', file)
    }
  }
}

export default download
